// @owners { team: patients }
import { COLORS, SIZES } from '@alto/design-library-tokens';
import { Border, Icon, Row, isFuzeRxBrand } from '@alto/design-system';
import React from 'react';

/**
 * Display a pill icon with background color. Used as a placeholder for medications without an image.
 *
 * FuzeRx uses the one-step-darker primary tint (primary.000, PH-4256) so the placeholder still reads
 * as a tile against the neutral surfaces the rest of its screens moved to.
 */
const getPlaceholderColor = () => (isFuzeRxBrand() ? COLORS.PALETTE.PRIMARY.LIGHT : COLORS.PALETTE.PRIMARY.LIGHTER);

type Props = {
  /** Tile size, defaults to the med row size. Essentials product tiles use XL. */
  readonly size?: keyof typeof SIZES.ILLUSTRATION;
};

export const Pill = ({ size = 'SM' }: Props) => {
  const placeholderColor = getPlaceholderColor();
  const tileSize = SIZES.ILLUSTRATION[size].value;

  return (
    <Border
      radius="MD"
      color={placeholderColor}
    >
      <Row
        center
        backgroundColor={placeholderColor}
        style={{ width: tileSize, height: tileSize }}
        testID="pill-icon"
      >
        <Icon name="capsule" />
      </Row>
    </Border>
  );
};
